import './bootstrap';
import './assets/styles/app.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthRedirect from "./Components/AuthRedirect";
import { AuthProvider } from "./context/AuthContext";
import GlobalDirector from './Components/GlobalDirector';
import ProtectedLayout from './Layouts/ProtectedLayout';
import RequireAuth from './guards/RequireAuth';

import { ToastProvider } from "./shadcn/ui/toast";
import { Toaster } from "./shadcn/ui/toaster";

import PasswordReset from './Pages/Auth/PasswordReset';
import EmailVerified from "./Components/EmailVerified";

import Login from "./Pages/Auth/Login";
import Dashboard from "./Pages/Dashboard";
import NotFound from "./Pages/NotFound";
import ProfilePage from "./Pages/Profile/Edit";
import ProtectedRoute from "./Components/ProtectedRoute";
import CategoryPage from "./Pages/CategoryPage";
import ProductsPage from "./Pages/Products";
import MediaPage from "./Pages/MediaPage";
import SettingsPage from "./Pages/SettingsPage";
import MenuBuilderPage from "./Pages/MenuBuilderPage";
import NewUser from "./Pages/Auth/NewUser";
import ForgotPassword from "./Pages/Auth/ForgotPassword";
import VerifyEmail from "./Components/VerifyEmail";
import Setup2FA from "./Pages/Auth/Setup2FA";
import Verify2FA from "./Pages/Auth/Verify2FA";
import ViewQrCode from "./Pages/Auth/ViewQrCode";
import PrivateBlendPage from "./Pages/PrivateBlendPage";

const App = () => {
    return (
        <ToastProvider swipeDirection="left">
            <AuthProvider>
                <Routes>
                    {/* Public Routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/secure-qr-code/:hash" element={<ViewQrCode />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/password-reset/:token" element={<PasswordReset />} />
                    <Route path="/email-verified" element={<EmailVerified />} />

                    {/* Email Verification Route */}
                    <Route
                        path="/verify-email"
                        element={
                            <RequireAuth>
                                <VerifyEmail />
                            </RequireAuth>
                        }
                    />

                    {/* Two-Factor Setup Route */}
                    <Route
                        path="/setup-2fa"
                        element={
                            <RequireAuth>
                                <Setup2FA />
                            </RequireAuth>
                        }
                    />

                    {/* Two-Factor Verification Route */}
                    <Route
                        path="/verify-2fa"
                        element={
                            <RequireAuth>
                                <Verify2FA />
                            </RequireAuth>
                        }
                    />

                    {/* Protected Routes */}
                    <Route path="/" element={<ProtectedLayout />}>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="coffees" element={<CategoryPage />} />
                        <Route path="drinks" element={<CategoryPage />} />
                        <Route path="blends" element={<CategoryPage />} />
                        <Route path="products" element={<ProductsPage />} />
                        <Route path="media" element={<MediaPage />} />
                        <Route path="profile" element={<ProfilePage />} />
                        <Route path="new-user" element={<NewUser />} />
                        <Route path="settings" element={<SettingsPage />} />
                        <Route path="private-blend" element={<PrivateBlendPage />} />
                        <Route
                            path="menu-builder"
                            element={
                                <MenuBuilderPage
                                    storageKey="menuBuilderDraft-header"
                                    title="Διαμόρφωση Μενού (Header)"
                                    description="Επιλέξτε ποιες κατηγορίες θα εμφανίζονται στο κύριο μενού."
                                    allowDropdowns={true}
                                />
                            }
                        />
                        <Route
                            path="menu-builder-footer"
                            element={
                                <MenuBuilderPage
                                    storageKey="menuBuilderDraft-footer"
                                    title="Διαμόρφωση Footer"
                                    description="Τα στοιχεία του footer δεν υποστηρίζουν dropdown. Επιλέξτε απλές κατηγορίες και ορίστε τη σειρά."
                                    allowDropdowns={false}
                                />
                            }
                        />
                        <Route path=":slug" element={<CategoryPage />} />
                    </Route>

                    {/* Catch-All Route */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <Toaster />
            </AuthProvider>
        </ToastProvider>
    );
};
export default App;
